import { useHead } from '@unhead/react'

interface SeoProps {
  title: string
  description: string
  path: string
  jsonLd?: Record<string, any> | Record<string, any>[]
}

const SITE_URL = 'https://www.muitamidiaofc.com.br'

function Seo({ title, description, path, jsonLd }: SeoProps) {
  const url = `${SITE_URL}${path}`
  const scripts = jsonLd
    ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).map(schema => ({
        type: 'application/ld+json',
        innerHTML: JSON.stringify(schema),
      }))
    : []

  useHead({
    title,
    htmlAttrs: { lang: 'pt-BR' },
    meta: [
      { name: 'description', content: description },
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: url },
      { property: 'og:locale', content: 'pt_BR' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description },
      { name: 'robots', content: 'index, follow' },
    ],
    link: [{ rel: 'canonical', href: url }],
    script: scripts,
  })

  return null
}

export default Seo
